export const titles = {
  issuerTitle: 'LOYO by Atomic',
};
